export default [
  'Tendered Loads',
  'Cancelled & Expired',
  'Rejected Tenders',
  'Active Loads',
  'Archived Loads'
];
